import { httpOpen } from './network'
import {getBrowserType} from '../scripts/util'
const browser = getBrowserType()
const { wechatId,publicPath } = process.env.CONFIG
const { wx } = window
class Wechat {
  ready = false;
  shareData = null;
  cancelCallBack = null;
  reset(){
    this.ready = false;
    this.cancelCallBack && this.cancelCallBack()
  }
  
  async init() {
    this.ready = false;
    try {
      let ret = await httpOpen('/Common/GetWXSignature', {
        type: 'post', body: {
          AppId: wechatId,
          Url: window.location.href.split("#")[0]
        }
      },(c) => {this.cancelCallBack = c})
      this.cancelCallBack = null;
      console.log(ret)
      wx.config({
        debug: false,
        appId: wechatId,
        timestamp: ret.Data.timestamp,
        nonceStr: ret.Data.nonceStr,
        signature: ret.Data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData','chooseCard','addCard','scanQRCode','chooseImage','getLocalImgData']
      });
      wx.ready(()=>{
        this.ready = true;
        console.log("wechat js sdk init ok")
        this.updateShare(this.shareData)
      });
      wx.error(()=>{
        this.ready = false;
        console.log("wechat js sdk init error")
      })
    } catch (e) {
      console.error(e)
    }
  }

  updateShare(data){
    this.shareData = data;
    if(!data || !this.ready) {
      return;
    }
    wx.updateAppMessageShareData({ 
      title: data.title, 
      desc: data.desc,
      link: data.link, 
      imgUrl: data.image, 
      success: function () {
        console.log("share message reset done")
      }
    })
    wx.updateTimelineShareData({ 
      title: data.title, 
      link: data.link, 
      imgUrl: data.image, 
      success: function () {
        console.log("share timeline reset done")
      }
    })
  }
  async addCard(card,callback){
    if(!card || !this.ready) {
      callback(false)
      return;
    }
    let ret = await httpOpen("/WuYouCard/GetWXCardExt",{
      type:"post",
      body:{
        AppId: wechatId,
        CardId: card
      }
    })
    if(ret.Status){
      callback(0)
      wx.addCard({
        cardList: [
          {
            cardId: card,
            cardExt: JSON.stringify(ret.Data),
          },
        ],
      });
    }else{
      callback(parseInt(ret.ErrorCode))
    }
  }
  scanQRCode(resolve,reject){
    wx.scanQRCode({
      needResult: 1,
      scanType: ["qrCode"], 
      success: function (res) {
        resolve(res.resultStr) 
      },
      fail:function (res) {
        reject(res) 
      }
    });
  }
  takePic(resolve,reject){
    wx.chooseImage({
      count: 1,
      sizeType: ['original'],
      sourceType: ['camera'],
      success:function(res){
        resolve(res.localIds)
      },
      fail:function (res) {
        reject(res) 
      }
    })
  }
  loadPic(resId,resolve,reject){
    wx.chooseImage({
      count: 1,
      sizeType: ['original'],
      sourceType: ['camera'],
      success:function(res){
        resolve(res.localIds)
      },
      fail:function (res) {
        reject(res) 
      }
    })
  }
}

export default function(router){
  let wechat = null;
  if(browser === "wechat"){
    wechat = new Wechat()
    wechat.init()
    router.addIntercept((to) => {
      if(to.meta.share === 'default'){
        wechat.updateShare({
          title:'品胜',
          link: window.location.origin + publicPath + '/home',
          desc: '买手机·修手机·玩手机',
          image: window.location.origin + publicPath + '/static/share_logo.jpg'
        })
      }
    })
  }
  return {
    install: (vue) =>{
      vue.mixin({
        created: function(){
          this.updateShare = function(data){
            if(wechat){
              wechat.updateShare(data)
            }
          }
          this.addWechatCard = function(data){
            return new Promise((resolve) => {
              if(wechat){
                let callback = (res) =>{
                  resolve(res)
                }
                wechat.addCard(data,callback)
              }else{
                resolve(false)
              } 
            })
           
          }
          this.scanQRCode = function(){
            return new Promise((resolve,reject) => {
              if(wechat){
                wechat.scanQRCode(resolve,reject)
              }else{
                reject("wechat is not init")
              } 
            })
          }
          this.takePic = function(){
            return new Promise((resolve,reject)=>{
              if(wechat){
                wechat.takePic(resolve,reject)
              }else{
                reject("wechat is not init")
              } 
            }) 
          }
        }
      })
    }
  }
}
